import React from 'react';

// eslint-disable-next-line react/prop-types
const QrRedirectPreview = ({ value }) => (
  <div>
    <h4>{JSON.stringify(value)}</h4>
  </div>
);

export default QrRedirectPreview;
